import { AccessibilityKey } from "../entity";
import { ElementTag } from "../../dom";

export class AccessibilityHandler {
    public static handleActionWithCallback(event: KeyboardEvent, callback: () => void): void {
        if (!this.isAccessibilityActionProvoked(event)) {
            return;
        }

        event.preventDefault();
        callback();
    }

    public static handleActionWithNestedLink(event: KeyboardEvent) {
        if (!this.isAccessibilityActionProvoked(event)) {
            return;
        }

        event.preventDefault();
        const focusedElement = event.target as HTMLElement;
        const closestAnchor = focusedElement.closest<HTMLAnchorElement>(ElementTag.ANCHOR);

        if (!closestAnchor) {
            return;
        }

        closestAnchor.click();
    }

    private static isAccessibilityActionProvoked(event: KeyboardEvent): boolean {
        return event.key === AccessibilityKey.SPACEBAR || event.key === AccessibilityKey.ENTER;
    }
}